import { getSelectedMethodShippingUtil } from 'modules/shipping/utils/get-selected-method'
import { SHIPPING_DOMAIN, SHIPPING_STATE } from 'modules/shipping/constants'
import { isUnrecognizedAddressShippingSelector } from 'modules/shipping/selectors/is-unrecognized'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'

/**
 * Resets the domain to its initial state.
 * @returns {Function}
 */
function resetShippingAction () {
  return (dispatch, getState) => {
    // If there is no shipping options
    // and the previous address was not recognized, noop
    if (
      !getSelectedMethodShippingUtil(getState()) &&
      !isUnrecognizedAddressShippingSelector()(getState())
    ) {
      return
    }
    return dispatch(
      updateLegacyReduxAction({
        path: SHIPPING_DOMAIN,
        value: SHIPPING_STATE
      })
    )
  }
}

export {
  resetShippingAction
}
